/**
 * Gala card color swatch (refresh design 2026).
 *
 * Gestisce gli swatch colore dentro card-product.liquid sui listing:
 * - click swatch -> naviga a product URL con ?variant=ID
 * - hover swatch -> sostituisce SOLO la primary image della card con
 *   l'immagine della variante (preserva srcset valido se disponibile)
 * - mouseleave -> ripristina src/srcset originali
 *
 * Sostituisce lo script inline duplicato che girava una volta per card
 * (causa principale delle thumbnail rotte: sovrascriveva anche la hover
 * image di Dawn e le .card-color-variant pre-renderizzate per Fase 7C,
 * con srcset invalido = singolo URL senza descrittore w).
 *
 * Architettura:
 * - Singleton: una sola istanza per pagina, event delegation su document.
 * - Target ristretto: tocca SOLO la primary img dentro .card__media .media,
 *   esclude .card-color-variant (sorgenti Fase 7C) e la secondary hover img.
 * - Original src/srcset salvati per-img su dataset prima del primo swap.
 * - Match swatch -> .card-color-variant case-insensitive: se trovata,
 *   usa il suo srcset (valido, con descrittori w); altrimenti fallback
 *   a data-variant-image dello swatch (singolo URL 533w).
 */
(function () {
  'use strict';
  if (window.__galaCardSwatchInit) return;
  window.__galaCardSwatchInit = true;

  // Preload variant images when card enters viewport (via IntersectionObserver).
  // Idempotent: cards marked with dataset.galaPreloaded skip subsequent triggers.
  function preloadCard(card) {
    if (card.dataset.galaPreloaded) return;
    card.dataset.galaPreloaded = '1';
    var swatches = card.querySelectorAll('.gala-swatch-wrapper');
    for (var i = 0; i < swatches.length; i++) {
      var src = swatches[i].getAttribute('data-variant-image')
        || swatches[i].getAttribute('data-variant-image-backup')
        || '';
      if (!src) continue;
      if (src.indexOf('//') === 0) src = 'https:' + src;
      // Force JPEG progressive: scarta eventuale risposta image/jxl cachata
      // sul CDN Shopify (decode fail su Chrome/FF/Edge, broken thumbs).
      if (src.indexOf('format=') < 0) {
        src += (src.indexOf('?') < 0 ? '?' : '&') + 'format=pjpg';
      }
      var img = new Image();
      img.decoding = 'async';
      img.src = src;
    }
  }

  function initPreloadObserver() {
    if (!('IntersectionObserver' in window)) {
      // Fallback: preload all immediately
      document.querySelectorAll('.card-wrapper').forEach(preloadCard);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) preloadCard(e.target);
      });
    }, { rootMargin: '200px 0px', threshold: 0.01 });
    document.querySelectorAll('.card-wrapper').forEach(function (c) { io.observe(c); });
    // Re-observe new cards added later (Dawn re-renders on filter change)
    var mo = new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.classList && n.classList.contains('card-wrapper')) io.observe(n);
          if (n.querySelectorAll) n.querySelectorAll('.card-wrapper').forEach(function (c) { io.observe(c); });
        });
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPreloadObserver);
  } else {
    initPreloadObserver();
  }

  function getPrimaryImg(card) {
    var media = card.querySelector('.card__media .media');
    if (!media) return null;
    var imgs = media.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.classList.contains('card-color-variant')) continue;
      return img;
    }
    return null;
  }

  // Dawn applies .media--hover-effect: on card hover the secondary <img>
  // raises to opacity:1 and covers the (just swapped) primary. We hide it
  // during swatch hover so the colour swap is actually visible.
  function getSecondaryImg(card) {
    var media = card.querySelector('.card__media .media--hover-effect');
    if (!media) return null;
    var imgs = media.querySelectorAll('img');
    var nonVariant = [];
    for (var i = 0; i < imgs.length; i++) {
      if (!imgs[i].classList.contains('card-color-variant')) nonVariant.push(imgs[i]);
    }
    return nonVariant.length >= 2 ? nonVariant[1] : null;
  }

  function findVariantImg(card, color) {
    if (!color) return null;
    var target = color.toLowerCase();
    var variants = card.querySelectorAll('.card-color-variant[data-color-variant]');
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if ((v.getAttribute('data-color-variant') || '').toLowerCase() === target) return v;
    }
    return null;
  }

  function saveOriginal(img) {
    if (img.dataset.galaOriginalSrc) return;
    img.dataset.galaOriginalSrc = img.getAttribute('src') || '';
    img.dataset.galaOriginalSrcset = img.getAttribute('srcset') || '';
    // Salva i srcset originali delle <source> del <picture> wrapper.
    var pic = img.closest('picture');
    if (!pic) return;
    var sources = pic.querySelectorAll('source');
    for (var i = 0; i < sources.length; i++) {
      if (typeof sources[i].dataset.galaOriginalSrcset === 'undefined') {
        sources[i].dataset.galaOriginalSrcset = sources[i].getAttribute('srcset') || '';
      }
    }
  }

  // Aggiorna le <source> del <picture> wrapper. webpSrcset opzionale: se
  // assente azzera la source webp (browser fallback su <img>).
  function updatePictureSources(img, webpSrcset) {
    var pic = img.closest('picture');
    if (!pic) return;
    var webp = pic.querySelector('source[type="image/webp"]');
    if (!webp) return;
    if (webpSrcset) {
      webp.setAttribute('srcset', webpSrcset);
    } else {
      webp.removeAttribute('srcset');
    }
  }

  function restorePictureSources(img) {
    var pic = img.closest('picture');
    if (!pic) return;
    var sources = pic.querySelectorAll('source');
    for (var i = 0; i < sources.length; i++) {
      var orig = sources[i].dataset.galaOriginalSrcset;
      if (typeof orig === 'undefined') continue;
      if (orig) {
        sources[i].setAttribute('srcset', orig);
      } else {
        sources[i].removeAttribute('srcset');
      }
    }
  }

  function swapPrimary(card, swatch) {
    var img = getPrimaryImg(card);
    if (!img) return;
    saveOriginal(img);

    // Force eager loading: lazy images may not fetch immediately on src change.
    // Save original loading attribute to restore on mouseleave.
    if (img.getAttribute('loading') === 'lazy') {
      if (!img.dataset.galaOriginalLoading) img.dataset.galaOriginalLoading = 'lazy';
      img.setAttribute('loading', 'eager');
    }
    if (!img.fetchPriority || img.fetchPriority === 'auto' || img.fetchPriority === 'low') {
      if (!img.dataset.galaOriginalFetchpriority) img.dataset.galaOriginalFetchpriority = img.fetchPriority || 'auto';
      img.fetchPriority = 'high';
    }

    // Hide Dawn secondary hover image so the swapped primary is actually visible.
    var secondary = getSecondaryImg(card);
    if (secondary && secondary.style.opacity !== '0') {
      if (!secondary.dataset.galaOriginalOpacity) {
        secondary.dataset.galaOriginalOpacity = secondary.style.opacity || '';
      }
      secondary.style.opacity = '0';
    }

    var color = swatch.getAttribute('data-color') || '';
    var variantImg = findVariantImg(card, color);

    if (variantImg) {
      var srcset = variantImg.getAttribute('srcset');
      var src = variantImg.getAttribute('src');
      var srcsetWebp = variantImg.getAttribute('data-srcset-webp');
      if (srcset) img.setAttribute('srcset', srcset);
      if (src) img.setAttribute('src', src);
      updatePictureSources(img, srcsetWebp);
      return;
    }

    var fallback = swatch.getAttribute('data-variant-image')
      || swatch.getAttribute('data-variant-image-backup')
      || '';
    if (!fallback) return;
    var fullUrl = fallback.indexOf('//') === 0 ? 'https:' + fallback : fallback;
    // Force JPEG progressive: bypass eventuale cache CDN Shopify che serve
    // image/jxl (content-type non supportato fuori da Safari 17+).
    if (fullUrl.indexOf('format=') < 0) {
      fullUrl += (fullUrl.indexOf('?') < 0 ? '?' : '&') + 'format=pjpg';
    }
    img.setAttribute('src', fullUrl);
    img.removeAttribute('srcset');
    // Nessun srcset webp per il fallback single-URL: azzera <source webp>
    // cosi' il browser usa direttamente l'<img> con format=pjpg.
    updatePictureSources(img, null);
  }

  function restorePrimary(card) {
    var img = getPrimaryImg(card);
    if (!img || !img.dataset.galaOriginalSrc) return;
    img.setAttribute('src', img.dataset.galaOriginalSrc);
    if (img.dataset.galaOriginalSrcset) {
      img.setAttribute('srcset', img.dataset.galaOriginalSrcset);
    } else {
      img.removeAttribute('srcset');
    }
    restorePictureSources(img);
    if (img.dataset.galaOriginalLoading) {
      img.setAttribute('loading', img.dataset.galaOriginalLoading);
    }
    if (img.dataset.galaOriginalFetchpriority) {
      img.fetchPriority = img.dataset.galaOriginalFetchpriority;
    }
    var secondary = getSecondaryImg(card);
    if (secondary && typeof secondary.dataset.galaOriginalOpacity !== 'undefined') {
      secondary.style.opacity = secondary.dataset.galaOriginalOpacity;
      delete secondary.dataset.galaOriginalOpacity;
    }
  }

  document.addEventListener('mouseenter', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var swatch = t.closest('.gala-swatch-wrapper');
    if (!swatch) return;
    var card = swatch.closest('.card-wrapper');
    if (!card) return;
    swapPrimary(card, swatch);
  }, true);

  document.addEventListener('mouseleave', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var swatch = t.closest('.gala-swatch-wrapper');
    if (!swatch) return;
    var card = swatch.closest('.card-wrapper');
    if (!card) return;
    restorePrimary(card);
  }, true);

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var swatch = t.closest('.gala-swatch-wrapper');
    if (!swatch) return;
    var url = swatch.getAttribute('data-url');
    if (!url) return;
    e.preventDefault();
    e.stopPropagation();
    window.location.href = url;
  }, true);
})();
